import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onCloseShepherd", "onInsert", "onTyping"];
import { useEffect } from 'react';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { setTracker } from '../../../usage-tracking/clients/usageTracker';
import { flexColumnStyles } from '../../../editor-utilities/protected/constants';
import { prosemirrorInputClassName, prosemirrorMenuClassName } from './ProsemirrorRichTextEditor';
import AsyncProsemirrorRTE from './AsyncProsemirrorRTE';
import styled, { css } from 'foundations-theming/utils';
import { ComposerLoadingOverlay } from '../../../capability-editor/protected/loading';
import { jsx as _jsx } from "react/jsx-runtime";
export const prosemirrorPaddingStyles = css(["padding:", ";"], ({
  theme
}) => `${theme.space['200']} ${theme.space['400']}`);
const ProsemirrorStyleWrapper = styled.div.withConfig({
  displayName: "RichTextEditor__ProsemirrorStyleWrapper",
  componentId: "sc-15rqoml-0"
})(["background-color:", ";.", "{border:", " !important;padding:", " !important;min-height:155px;flex-grow:1;", ";flex-shrink:0;}.", " > div{flex-basis:1px;}.", "{display:flex;align-items:center;background-color:", ";", " flex-shrink:0;transition:opacity 0.2s ease-in-out;}.prosemirror-formatting-tray{", "}.ProseMirror{flex-shrink:1;flex-basis:0;", " font-size:", ";}.ProseMirrorPlaceholder{", "}flex-grow:1;position:relative;display:flex;flex-direction:column;align-items:stretch;flex-basis:1px;"], ({
  theme
}) => theme.color['fill-surface-default'], prosemirrorInputClassName, ({
  theme
}) => theme.borderWidth['0'], ({
  theme
}) => theme.space['0'], flexColumnStyles, prosemirrorInputClassName, prosemirrorMenuClassName, ({
  theme
}) => theme.color['fill-field-default'], prosemirrorPaddingStyles, prosemirrorPaddingStyles, prosemirrorPaddingStyles, ({
  theme
}) => theme.typography['body-200'].fontSize, prosemirrorPaddingStyles);
const RichTextEditor = props => {
  const {
    asyncCapabilitiesConfig,
    isConfigLoading,
    prosemirrorConfig,
    tracker,
    trackingContext
  } = props;
  const prosemirrorStyleProps = _objectWithoutPropertiesLoose(props, _excluded);
  useEffect(() => {
    setTracker(tracker, trackingContext);
  }, [tracker, trackingContext]);
  if (isLoading(asyncCapabilitiesConfig) || isConfigLoading) {
    return /*#__PURE__*/_jsx(ComposerLoadingOverlay, {});
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ProsemirrorStyleWrapper, Object.assign({}, prosemirrorStyleProps, {
      children: /*#__PURE__*/_jsx(AsyncProsemirrorRTE, Object.assign({}, props, {
        prosemirrorConfig: prosemirrorConfig,
        capabilitiesConfig: getData(asyncCapabilitiesConfig) || {}
      }))
    }))
  );
};
RichTextEditor.displayName = 'RichTextEditor';
export default RichTextEditor;